import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEditSmall1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEditSmall1"><Path d="M10.5 7.31836V13.5H16.6816L21 9.18164V21H3V3H14.8184L10.5 7.31836Z" fill="currentColor"/><Path d="M22.8105 5.25L16.0605 12H12V7.93945L18.75 1.18945L22.8105 5.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEditSmall1;
